<template>
  <mds-modal
    :aria-label="translate('fullScreenModal')"
    action-required
    :visible="visible"
    :fullscreen="settings.enableFullscreenFeeScheduleModal"
  >
    <mds-section :class="$style['scroll_section']" border="none">
      <fee-schedule-summary-list
        :mwc-id="`${rootMwcId}.fee-schedule-summary-list`"
        :config="feeScheduleSummaryListMwcConfig"
        :actived-fee-schedule-id="feeScheduleId"
        :user-id="userInfo.userId"
        :environment="environment"
        :show-create-buttons="showCreateButtons"
        :show-fee-types="showFeeTypes"
        :viewable-sources="viewableSources"
        :is-fee-schedules-from-api="!settings.isActualWorkflow"
        :fee-schedules="feeSchedules"
        @active-schedule-changed="$emit('active-schedule-changed', $event)"
        @fee-schedules-updated="$emit('fee-schedules-updated', $event)"
        @back-button-clicked="$emit('back-button-clicked')"
      >
      </fee-schedule-summary-list>
    </mds-section>
  </mds-modal>
</template>

<script>
import MwcVueHelperMixin, { MwcConfigMixin } from 'mwc-vue-component-helper';
import MdsModal from '@mds/modal';
import MdsSection from '@mds/section';
import FeeScheduleSummaryList from 'hypo-fee-schedule-summary-list/src/FeeScheduleSummaryList';
import { SOURCE, USER_LEVEL } from '../../../utils/constants';

export default {
  name: 'fee-schedule-summary-list-modal',
  components: {
    FeeScheduleSummaryList,
    MdsModal,
    MdsSection,
  },
  mixins: [MwcVueHelperMixin, MwcConfigMixin],
  model: {
    prop: 'visible',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    environment: String,
    assetBasedFeeConfig: {
      type: Object,
      default: () => {},
    },
    userInfo: Object,
    feeScheduleId: {
      type: String,
      default: null,
    },
    feeSchedules: {
      type: Array,
      default: () => [],
    },
  },
  inject: ['rootMwcId'],
  computed: {
    feeScheduleSummaryListMwcConfig() {
      return {
        settings: {
          languageId: this.settings.languageId,
          isActualWorkflow: this.settings.isActualWorkflow,
          showBackButton: this.settings.showBackButton,
        },
      };
    },
    showFeeTypes() {
      return {
        showMaxFee: this.assetBasedFeeConfig.allowAssetBasedMaxFee,
        showFeeSchedule: this.assetBasedFeeConfig.allowAssetBasedFeeSchedule,
      };
    },
    showCreateButtons() {
      return {
        createSchedule: this.getButtonPermission(),
        createMaxFee: this.getButtonPermission('maxFee'),
      };
    },
    viewableSources() {
      const { maxFeeOrFeeScheduleSource } = this.assetBasedFeeConfig;
      const isAdmin =
        this.userInfo.userLevel === USER_LEVEL.SUPER_ADMIN ||
        this.userInfo.userLevel === USER_LEVEL.GROUP_ADMIN; // Temporary fix firm admin flag.
      return {
        firmSaved: maxFeeOrFeeScheduleSource.includes(SOURCE.ADMIN_CREATED),
        normalUserSaved: maxFeeOrFeeScheduleSource.includes(SOURCE.NORMAL_USER_CREATED) || isAdmin,
        firmData: maxFeeOrFeeScheduleSource.includes(SOURCE.DATA_COLLECTION),
      };
    },
  },
  methods: {
    getButtonPermission(feeScheduleType) {
      const {
        allowAssetBasedFeeSchedule,
        allowAssetBasedMaxFee,
        maxFeeOrFeeScheduleSource,
      } = this.assetBasedFeeConfig;

      const allowType =
        feeScheduleType === 'maxFee' ? allowAssetBasedMaxFee : allowAssetBasedFeeSchedule;
      const allowNormalUser = maxFeeOrFeeScheduleSource.includes(SOURCE.NORMAL_USER_CREATED);
      const hasAdminRight =
        maxFeeOrFeeScheduleSource.includes(SOURCE.ADMIN_CREATED) &&
        this.userInfo.userLevel !== USER_LEVEL.NORMAL;

      return allowType && (allowNormalUser || hasAdminRight);
    },
  },
};
</script>

<style lang="scss" module>
@import '@mds/constants';

.scroll_section {
  overflow: auto;
  .hypo-fee-schedule-summary-list .fee-schedule-content {
    width: 800px;
  }
}

.mds-tooltip,
.mds-popover {
  z-index: $mds-z-index-modal-content; //top on full screen modal
}
</style>
